export const ErrorMessage: React.FC<{ error: string }> = ({ error }) => {
	return <p className="mt-2 mb-2 text-sm text-red-500">{error}</p>
}
